"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LanguageInterceptor {
    constructor(unitMutable) {
        this.unitMutable = unitMutable;
        this.intercept = async (request) => {
            return {
                ...request,
                headers: {
                    ...request.headers,
                    "Accept-Language": this.unitMutable.get(),
                },
            };
        };
    }
}
exports.default = LanguageInterceptor;
//# sourceMappingURL=LanguageInterceptor.js.map